/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
const Paystack = ({ Amount }) => {

    const { ApiBaseUrl, setApiLoading } = useContext(MyContext);

    const HandleCall = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        setApiLoading(true);
        axios.post(`${ApiBaseUrl}/customer/paystack-payment`, { amount: Amount, uid: Userid, status: "1", })
            .then((res) => {
                // console.log("paystack-payment", res);
                setTimeout(() => {
                    setApiLoading(false);
                }, 1000);
                window.location.href = res.data.PaystackURL;
            })
            .catch((error) => {
                console.error("paystack-payment", error);
            });
    };

    useEffect(() => {
        if (Amount) {
            HandleCall();
        }
    }, [Amount]);

    return null;
};

export default Paystack;
/* jshint ignore:end */